import React, {useMemo} from 'react'
import {List, useSlotRecipe} from '@chakra-ui/react3'
import PropTypes from 'prop-types'
import ModuleContainer from '../../components/cms/module-container'
import Heading from '../../components/cms/heading'
import Fade from '../../components/cms/fade'
import {cardsSlotRecipe} from './index.recipe'
import CardItem from './card-item'

const Cards = React.forwardRef(function Cards(
    {
        moduleId,
        moduleType,
        pageId,
        headingLevel,
        heading,
        anchor,
        background,
        variantCards,
        cards,
        spacing
    },
    ref
) {
    const recipe = useSlotRecipe({recipe: cardsSlotRecipe})
    const styles = useMemo(
        () => recipe({variant: variantCards, count: String(cards.length)}), // count must be a string to match the recipe
        [cards.length, recipe, variantCards]
    )

    return (
        <ModuleContainer
            moduleId={moduleId}
            moduleType={moduleType}
            ref={ref}
            pageId={pageId}
            anchor={anchor}
            background={background}
            spacing={spacing}
            {...styles.moduleContainer}
        >
            <Fade>
                <Heading
                    {...heading}
                    headingLevel={headingLevel}
                    alignment={{base: 'left', s: 'center'}}
                ></Heading>
            </Fade>

            <List.Root variant="noIndicator" {...styles.cards}>
                {cards.map((card, idx) => (
                    <CardItem
                        key={idx}
                        card={card}
                        headingLevel={headingLevel}
                        styles={styles}
                        variant={variantCards}
                        trackingContext={{moduleName: moduleType, eventLabel: 'cta'}}
                    />
                ))}
            </List.Root>
        </ModuleContainer>
    )
})

if (process.env.NODE_ENV !== 'production') {
    Cards.displayName = 'Cards'
}

Cards.propTypes = {
    headingLevel: PropTypes.number,
    heading: PropTypes.object,
    background: PropTypes.oneOf(['default', 'subtle', 'strong', 'inverse']),
    anchor: PropTypes.string,
    variantCards: PropTypes.oneOf(['default', 'condensed', 'with-overlay']),
    cards: PropTypes.array,
    moduleId: PropTypes.string,
    moduleType: PropTypes.string,
    pageId: PropTypes.string,
    spacing: PropTypes.oneOf(['default', 'reduced', 'min', 'min-top', 'min-bottom'])
}

export default Cards
